//@flow

import {ActionCreator, createReducer} from '../../../store/utils';

import type {ChatTrigger, Pagination} from '../../../entities';
export type ChatTriggerState = {
  isFetchingTriggers: boolean,
  triggers: ChatTrigger[],
  pagination?: Pagination,
};

export type ChatTriggerAction = {
  triggers?: ChatTrigger[],
  pagination?: Pagination,
  triggerId?: string,
  page?: number,
};

export const initialState: ChatTriggerState = {
  isFetchingTriggers: false,
  triggers: [],
};

/* export class FetchTriggers extends ActionCreator<ChatTriggerAction> {}
export class FetchTriggersSuccess extends ActionCreator<ChatTriggerAction> {}
export class FetchTriggersError extends ActionCreator<ChatTriggerAction> {}
 */
export class SetTriggers extends ActionCreator<ChatTriggerAction> {}
export class DeleteTrigger extends ActionCreator<ChatTriggerAction> {}
export class AddTrigger extends ActionCreator<ChatTriggerAction> {}
export class EditTrigger extends ActionCreator<ChatTriggerAction> {}
export class SetPaginationPage extends ActionCreator<ChatTriggerAction> {}

export const actions = {
  // fetchTriggers: new FetchTriggers(),
  setTriggers: (triggers: ChatTrigger[], pagination: Pagination) =>
    new SetTriggers({triggers, pagination}),
  deleteTrigger: (triggerId: string) => new DeleteTrigger({triggerId}),
  addTrigger: (trigger: ChatTrigger) => new AddTrigger({trigger}),
  editTrigger: (trigger: ChatTrigger) => new EditTrigger({trigger}),
  setPaginationPage: (page: number) => new SetPaginationPage({page}),
};

export default createReducer(initialState, {
  [SetTriggers.type]: (state, action) => ({
    ...state,
    triggers: action.triggers,
    pagination: action.pagination,
  }),
  [DeleteTrigger.type]: (state, action) => ({
    ...state,
    triggers: state.triggers.filter(trigger => trigger.id !== action.triggerId),
  }),
  [AddTrigger.type]: (state, action) => ({
    ...state,
    triggers: [...state.triggers, action.trigger],
  }),
  [EditTrigger.type]: (state, action) => ({
    ...state,
    triggers: state.triggers.map(trigger =>
      trigger.id === action.trigger.id ? action.trigger : trigger
    ),
  }),
  [SetPaginationPage.type]: (state, action) => ({
    ...state,
    pagination: {
      ...state.pagination,
      page: action.page,
    },
  }),
});

/* export function fetchTriggersEpic(action$: ActionsObservable) {
  return action$.pipe(
    ofType(FetchTriggers.type),
    debounceTime(500),
    switchMap(() => {
      return getTriggersEndpoint().pipe(
        map(() => new FetchTriggersSuccess()),
        buildCatchError(FetchTriggersError)
      );
    })
  );
}
 */
